<template>
  <AutoCompleter ref="completer" :placeholder="placeholder" :results="results" :iid="iid" @reload="reload" @selected="selectValue">
    <template v-slot:listitem="data">
      {{ data.result.map_id }} - {{ data.result.customer.title }}
    </template>
  </AutoCompleter>
</template>

<script>
import offers from '@/modules/offers.js'
import AutoCompleter from '@/components/AutoCompleter.vue'

export default {
  name: 'OffersAutoCompleter',
  props: ["iid","placeholder"],
  components: {
    AutoCompleter,
  },
  data() {
    return {
      results: [],
    }
  },
  created: function() {
    offers.viewparams.page = 1;
  },
  methods: {
    selectValue(data) {
      var link = { title: data.map_id + ' ' + data.customer.title + ' (' + data.customerid + ')'};
      this.$refs.completer.updateValue(data.id,link);
    },
    reload(search) {
      console.log(search);
      offers.viewparams.search = search;
      var self = this;
      offers.list(function(data) {
        self.results = data.rows;
      })
    }
  }
}
</script>
